import { createContext } from "react";

export interface CollapseContextValue {
  /**
   * 当前激活的面板 ID
   */
  activeIds: string[];

  /**
   * 面板激活变化回调
   */
  onActive: (
    activeIds: string[],
    context: { event: React.SyntheticEvent; activeId: string; active: boolean }
  ) => void;

  /**
   * 切换图标
   */
  icon?: React.ReactNode | ((active: boolean) => React.ReactNode);

  /**
   * 图标位置
   * @default "left"
   */
  iconPosition?: "left" | "right";

  /**
   * 是否在切换时销毁未激活的 Panel
   */
  destroyInactivePanel?: boolean;
}

export const CollapseContext = createContext<CollapseContextValue>({
  activeIds: [],
  onActive: () => null,
});
